import React from 'react';
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { NeoReport, Report } from '@singularsystems/neo-reporting';
import ValuelessSecurityTransactionsReportCriteria from './ValuelessSecurityTransactionsReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("ValuelessSecurityTransactions", { category: MaintenanceReportCategories.DataValidationReports })
export default class ValuelessSecurityTransactionsReport extends Report<ValuelessSecurityTransactionsReportCriteria> {

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)) {
        super(ValuelessSecurityTransactionsReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={4}>
                    <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                        <Neo.AutoCompleteDropDown
                            itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                            bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                            bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                            displayMember={"serviceProviderGroupingName"}
                            items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                    </Neo.FormGroup>
                    <Neo.FormGroup
                        label={TextConstants.Labels.BrokerAccount}
                        bind={this.criteria.meta.rawAccountNumber}
                    />
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.startDate}
                    />
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.endDate}
                    />
                </Neo.GridLayout >
            </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}